export interface IState {
  inventoryCategory: any;
  inventoryStorageLocation: any;
  inventoryShippingBy: any;
  inventoryList: any;
  inventroyCount: number;
  selectedVendor: any;
  signInHistoryData: any;
  signInHistoryCount: number;
  signOutHistoryData: any;
  signOutHistoryCount: number;
  signOutSerialNumber: any;
  inventoryLastId: any;
  inventoryUniqueLocation: any;
  inventoryBoatList: any;
  inventoryFilterData: any;
  sindleInventory: any;
}

type Action = any;

export const InventoryReducer = (
  state: IState = {
    inventoryCategory: [],
    inventoryStorageLocation: [],
    inventoryShippingBy: [],
    inventoryList: [],
    inventroyCount: 0,
    selectedVendor: {},
    signInHistoryData: [],
    signInHistoryCount: 0,
    signOutSerialNumber: [],
    signOutHistoryData: [],
    signOutHistoryCount: 0,
    inventoryLastId: "",
    inventoryUniqueLocation: [],
    inventoryBoatList: [],
    inventoryFilterData: null,
    sindleInventory: null,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_INVENTORY_CATEGORY":
      return {
        ...state,
        inventoryCategory: action?.payload,
      };
    case "GET_INVENTORY_STORAGE_LOCATION":
      return {
        ...state,
        inventoryStorageLocation: action?.payload,
      };

    case "GET_INVENTORY_SHIPPING_BY":
      return {
        ...state,
        inventoryShippingBy: action?.payload,
      };

    case "GET_INVENTORY":
      return {
        ...state,
        inventoryList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.inventoryList, ...action?.payload?.data],
        inventroyCount: action?.payload?.count,
      };
    case "GET_SINGLE_INVENTORY":
      return {
        ...state,
        sindleInventory: action?.payload?.data[0],
      };
    case "GET_VANDOR_DETAILS_WITH_INVENTORY":
      return {
        ...state,
        inventoryList: action?.payload?.inventories || [],
        selectedVendor: action?.payload?.vendor || {},
      };

    case "GET_INVENTORY_SIGN_IN_HISTORY":
      return {
        ...state,
        signInHistoryData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.signInHistoryData, ...action?.payload?.data],
        signInHistoryCount: action?.payload?.count,
      };
    case "GET_INVENTORY_SIGN_OUT_HISTORY":
      return {
        ...state,
        signOutHistoryData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.signOutHistoryData, ...action?.payload?.data],
        signOutHistoryCount: action?.payload?.count,
      };

    case "GET_INVENTORY_SERIAL_NUMBER":
      return {
        ...state,
        signOutSerialNumber: action?.payload,
      };
    case "DELETE_SIGN_IN_HISTORY":
      return {
        ...state,
        signInHistoryData: state?.signInHistoryData?.filter((elem: any) => elem?._id != action?.payload),
      };
    case "DELETE_SIGN_OUT_HISTORY":
      return {
        ...state,
        signOutHistoryData: state?.signOutHistoryData?.filter((elem: any) => elem?._id != action?.payload),
      };
    case "INVENTORY_REORDER":
      return {
        ...state,
        inventoryList: state?.inventoryList?.map((elem: any) => {
          if (action?.payload?.inventories?.includes(elem?._id)) {
            return {
              ...elem,
              is_reorder: action?.payload?.is_reorder,
            };
          }
          return elem;
        }),
      };

    case "GET_SKU_ID":
      function incrementSKU(sku: any) {
        try {
          if (!sku) return "1";
          const numberMatch = sku?.match(/(\d+)(?!.*\d)/); // find LAST number
          if (numberMatch) {
            // If number exists
            const num = numberMatch[0];
            const incremented = String(parseInt(num, 10) + 1)?.padStart(num?.length, "0"); // keep leading zeros
            return sku?.replace(/(\d+)(?!.*\d)/, incremented);
          } else {
            // If no number, increment last character(s)
            let chars = sku?.split("");
            for (let i = chars?.length - 1; i >= 0; i--) {
              if (/[a-zA-Z]/.test(chars[i])) {
                const isUpper = chars[i] === chars[i]?.toUpperCase();
                let code = chars[i]?.toUpperCase()?.charCodeAt(0);

                if (code === 90) {
                  // Z
                  chars[i] = isUpper ? "A" : "a"; // wrap around, preserve case
                  if (i === 0) chars?.unshift(isUpper ? "A" : "a"); // all wrapped, add another letter
                } else {
                  chars[i] = String.fromCharCode(code + 1);
                  if (!isUpper) chars[i] = chars[i]?.toLowerCase(); // preserve lowercase
                  break;
                }
              }
            }
            return chars.join("");
          }
        } catch (error) {
          console.error("incrementSKU failed:", error);
          return String(sku ?? "1"); // Fallback
        }
      }
      const finalSku = incrementSKU(action?.payload?.toString());
      return {
        ...state,
        inventoryLastId: finalSku,
      };
    case "GET_INVENTORY_UNIQUE_LOCATION":
      return {
        ...state,
        inventoryUniqueLocation: action?.payload,
      };

    case "GET_BOAT_LIST":
      return {
        ...state,
        inventoryBoatList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.inventoryBoatList, ...action.payload.data],
      };
    case "GET_INVENTORY_FILTER_DATA":
      return {
        ...state,
        inventoryFilterData: action?.payload,
      };
    case "DELETE_INVENTORY":
      return {
        ...state,
        inventoryList: state.inventoryList?.filter(
          (elem: any) => !action.payload.includes(elem._id)
        ),
      };
    case "UPDATE_SIGN_IN_HISTORY_DATA":
      return {
        ...state,
        signInHistoryData: state?.signInHistoryData?.map((elem: any) =>
          elem?._id == action?.payload?._id ? action?.payload : elem
        ),
      };
    case "CLEAR_INVENTORY_DATA":
      return {
        ...state,
        inventoryList: [],
      };
    default:
      return state;
  }
};
